// use this to validate type
import {RegionSlug} from "./types";

export const getRegionSlug = (slug: RegionSlug): RegionSlug => slug;
